export default __webpack_public_path__ + "static/media/angle-left.ecc84643.svg";